<template>
<main class="signup-form">
    <div class="container">
        <div class="row justify-content-center m-0">
            <div class="col-md-4">
                <div class="card">
                <div class="card-header normal">Reset Password</div>
                <div class="card-body">

            <div class="alert alert-danger text-center" role="alert" v-if="error_message">
                {{error_message}}
            </div>
            
            <div class="alert alert-success mb-0 text-center" role="alert" v-if="success_message">
            <span v-html="success_message"></span>
            </div>

            <div v-if="!submitted">
            <div class="form-group">
                <div class="d-flex justify-content-between">
                    <label for="reset-password-new">New Password</label>
                </div>
                <div class="input-group input-group-merge form-password-toggle">

                    <div class="input-group">
      <input v-if="showPassword" type="text" placeholder="Password" class="form-control password" v-model="password">
      <input v-else type="password" placeholder="Password" class="form-control password" v-model="password">
      <div class="input-group-append password" @click="toggleShow">
        <span class="input-group-text password"><i class="fas" :class="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"></i></span>
      </div>
    </div>
                    
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex justify-content-between">
                    <label for="reset-password-confirm">Confirm Password</label>
                </div>
                <div class="input-group input-group-merge form-password-toggle">

    <div class="input-group">
      <input v-if="showPassword_confirm" type="text" placeholder="Password Confirmation" class="form-control password" v-model="password_confirm">
      <input v-else type="password" placeholder="Password Confirmation" class="form-control password" v-model="password_confirm">
      <div class="input-group-append password" @click="toggleShow2">
        <span class="input-group-text password"><i class="fas" :class="{ 'fa-eye': showPassword_confirm, 'fa-eye-slash': !showPassword_confirm }"></i></span>
      </div>
    </div>
                    
                </div>
            </div>

            <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin fa-2x"></i></div>
            <button v-else class="btn btn-danger btn-block" @click="submitForm">Reset Password</button>

            </div>

            </div>
                
            </div>

            </div>
        </div>
    </div>
</main>
</template>

<script>

export default {
props: ['token','email'],
  data() {
    return {
      error_message: '',
      success_message: '',
      loading: false,
      submitted: false,
      password: '',
      password_confirm: '',
      showPassword: false,
      showPassword_confirm: false,
    };
  },

  created() {
    
  },

  methods: {

    toggleShow() {
      this.showPassword = !this.showPassword;
    },

    toggleShow2() {
      this.showPassword_confirm = !this.showPassword_confirm;
    },

      submitForm() {

          this.error_message = '';

          if (this.password=='') { this.sweetfire('Please enter your new password')}
          else if (this.password.length < 6) { this.sweetfire('Your password should be at least 6 characters long')}
          else if (this.password_confirm=='') { this.sweetfire('Please enter your new password again')}
          else if (this.password !== this.password_confirm) { this.sweetfire('Your passwords do not match')}

          else {

          this.loading = true;

          axios
          .post("/password-post-token", {email: this.email, token: this.token, password: this.password})
          .then((response) => {
            
            if (response.data.success) {
                this.success_message = response.data.message;
                this.submitted = true;
            }

            else this.error_message = response.data.message;
            
            this.loading = false;

          })
          .catch(function (err) {
            console.log(err);
            this.loading = false;
          });

          }
      
      },


    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: { title: "popup-title", },
    })

    },

  },
};
</script> 